import { FilterableQueryParams } from 'models/FilterableQueryParams';
import { Keyword } from 'models/Keyword';

export function getActiveKeyword(
  { category, keyword }: FilterableQueryParams,
  keywords?: Keyword[]
): Keyword | undefined {
  if (keywords && keywords.length > 0) {
    return keywords?.find(
      ({ urlPath }) => urlPath === `${category}/${keyword}`
    );
  }

  return undefined;
}
